import React, { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { api } from "@/lib/api";
import Turnstile from "@/components/site/Turnstile";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(null);
  const [status, setStatus] = useState({ state: "idle", error: "" });

  const captchaEnabled = !!process.env.REACT_APP_TURNSTILE_SITE_KEY;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || status.state === "loading") return;
    if (captchaEnabled && !token) {
      setStatus({ state: "error", error: "Please complete the captcha." });
      return;
    }
    setStatus({ state: "loading", error: "" });
    try {
      await api.post("/newsletter/subscribe", {
        email,
        turnstile_token: token || undefined,
      });
      setStatus({ state: "success", error: "" });
      setEmail("");
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.message ||
        "Subscription failed. Please try again.";
      setStatus({ state: "error", error: String(msg) });
    }
  };

  return (
    <div data-testid="newsletter-signup" className="mt-8">
      <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500 mb-3">
        Monthly Briefing
      </div>
      <p className="text-slate-300 text-sm leading-relaxed max-w-md mb-4">
        A short, disciplined dispatch — doctrine, fieldwork, and how the Coalition is
        standing watch. No noise.
      </p>
      <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-2 max-w-md">
        <label htmlFor="newsletter-email" className="sr-only">Email address</label>
        <input
          id="newsletter-email"
          data-testid="newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@institution.org"
          className="flex-1 bg-transparent border-b border-white/30 focus:border-amber-500 outline-none text-white placeholder:text-slate-500 py-3 text-sm"
        />
        <button
          type="submit"
          disabled={status.state === "loading"}
          data-testid="newsletter-submit"
          className="group inline-flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 disabled:opacity-60 text-white px-5 py-3 font-semibold text-sm transition-colors"
        >
          {status.state === "loading" ? "Subscribing…" : "Subscribe"}
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </button>
      </form>

      {captchaEnabled && (
        <div className="mt-4">
          <Turnstile onToken={setToken} theme="dark" size="compact" />
        </div>
      )}

      {status.state === "success" && (
        <p data-testid="newsletter-success" className="mt-3 inline-flex items-center gap-2 text-amber-400 text-sm">
          <Check size={14} /> Subscribed. Welcome to the briefing.
        </p>
      )}
      {status.state === "error" && (
        <p data-testid="newsletter-error" className="mt-3 text-rose-400 text-sm">
          {status.error}
        </p>
      )}
    </div>
  );
}
